import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      props: true
    },
    {
      path: "/chat?login=:userId",
      name: "chat",
      props: { usernameChoiced: true },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component() {
        return import(/* webpackChunkName: "about" */ "./views/Chat.vue")
      }
    },
    {
      path: "/chat",
      name: "chatBeforeLogin",
      props: { usernameChoiced: false},
      component: Home
    }
  ]
})
